function giftcertificateService(modalService) {
  const service = this;
  service.dialogOpen = function () {
    modalService.open('giftcertificatePreview');
  };
  service.dialogClose = function () {
    modalService.close('giftcertificatePreview');
  };
}
giftcertificateService.$inject = ["modalService"];
export default giftcertificateService;